/**
 * Request password form submission handler
 *
 * @param event
 */
window.solicitarContrasena = function (event) {
    event.preventDefault();
    $('#solicitarContrasenaError').hide();
    $('#solicitarContrasenaExito').hide();
    cleanFeedback('solicitarContrasena', 'solicitarContrasenaFormulario');
    let formData = new FormData(event.target);

    // Procesamos Recaptcha de Google
    appendGRecaptchaResponse(formData, recaptcha_actions.password_reset).then(function (formData) {

        // Detectamos si se ha enviado como identificador un código o un email
        let identificador = String(formData.get('identificador'));
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identificador)) {
            formData.delete('identificador');
            formData.append('email', identificador);
        } else if (/^[0-9]{1,7}$/.test(identificador)) {
            formData.delete('identificador');
            formData.append('codigo', identificador);
        } else {
            $('#solicitarContrasenaError').show().find('span').text(transAccionCamposIncorrectos);
        }

        // Enviamos la solicitud
        $.ajax({
            url:         urlAutenticacion + '/contrasenas',
            type:        'POST',
            data:        formData,
            processData: false,
            contentType: false,
            beforeSend:  function () {
                // Deshabilitamos el botón de envío si no se está reenviando la solicitud
                $('#solicitarContrasenaBotonEnviar').prop('disabled', true);
                $('#solicitarContrasenaBotonEnviar').html(`<i class="ri-loader-4-line spinner"></i>${transAccionProcesando}`);
            },
        })
         .done(function (response) {
             if (response.message === 'codigo_requerido') {
                 $('#solicitarContrasenaError').show().find('span').text(transCodigoRequerido);
                 $('#solicitarContrasenaFormularioCampoIdentificador').addClass('is-invalid').val('').focus();
             } else {
                 $('#solicitarContrasenaExito').show().find('span').text(response.message);
             }
         })
         .fail(function (jqXHR, status, error) {
             if (jqXHR.status === 422 && jqXHR.responseJSON.errors) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             $('#solicitarContrasenaError').show().find('span').html(errors);
         })
         .always(function () {
             // Rehabilitamos el botón de envío si no se está reenviando la solicitud
             $('#solicitarContrasenaBotonEnviar').prop('disabled', false);
             $('#solicitarContrasenaBotonEnviar').html(`<i class="ri-send-plane-2-fill me-2"></i> ${transAccionEnviar}`);
         });
    }) .catch(function () {
        $('#solicitarContrasenaError').show().find('span').text(transGRecaptchaErrorNotValidated);
    });
}
